// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1QdZd","load2":"Spinner_load2__30IQ9"};